export default __webpack_public_path__ + "images/logoEmmaHardie.df6d5740b446fe52ef5fe3cd4703bfe6.svg"